import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PendingPurchaseOrders';

const PendingPurchaseOrders = () => ((orgContainer(InnerComponent)));

export default PendingPurchaseOrders;
